"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TypographyStyle = {
    baseStyle: {
        fontWeight: 'semibold',
        fontFamily: 'heading',
    },
    variants: {
        display1: {
            fontSize: {
                base: '46px',
                lg: '62px',
            },
            lineHeight: {
                base: '56px',
                lg: '72px',
            },
        },
        display2: {
            fontSize: {
                base: '42px',
                lg: '52px',
            },
            lineHeight: {
                base: '42px',
                lg: '52px',
            },
        },
        h1: {
            fontSize: {
                base: '36px',
                lg: '42px',
            },
            lineHeight: {
                base: '44px',
                lg: '50px',
            },
        },
        h2: {
            fontSize: {
                base: '32px',
                lg: '36px',
            },
            lineHeight: {
                base: '40px',
                lg: '44px',
            },
        },
        h3: {
            fontSize: {
                base: '28px',
                lg: '32px',
            },
            lineHeight: {
                base: '36px',
                lg: '40px',
            },
        },
        h4: {
            fontSize: '24px',
            lineHeight: '32px',
        },
        h5: {
            fontSize: '22px',
            lineHeight: '30px',
        },
        h6: {
            fontSize: '20px',
            lineHeight: '28px',
        },
        subtitle1: {
            fontSize: '18px',
            lineHeight: '26px',
            fontFamily: 'body',
        },
        subtitle2: {
            fontSize: '16px',
            lineHeight: '24px',
            fontFamily: 'body',
        },
        subtitle3: {
            fontSize: '14px',
            lineHeight: '22px',
            fontFamily: 'body',
        },
        body1: {
            fontSize: '18px',
            lineHeight: '26px',
            fontFamily: 'body',
        },
        body2: {
            fontSize: '16px',
            lineHeight: '24px',
            fontFamily: 'body',
        },
        body3: {
            fontSize: '14px',
            lineHeight: '22px',
            fontFamily: 'body',
        },
        caption: {
            fontSize: '12px',
            lineHeight: '20px',
            fontFamily: 'body',
        },
    },
    defaultProps: {
        variant: 'h2',
    },
};
exports.default = TypographyStyle;
